import React, { useEffect, useMemo, useState } from 'react'
import ToolbarHeader from '../../components/ToolbarHeader';
import WrapperWithTabs from '../../components/WrapperWithTabs';
import useApi from '../../hooks/useApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiUrls } from '../../utils/api/apiUrls';
import moment from 'moment';
import { useAuth } from '../../contexts/AuthContext';
import DatePicker from '../../components/FormFields/DatePicker';
import CustomTable from '../../components/CustomTable';
import CustomButton from '../../components/CustomButton';
import { toast } from 'react-toastify';
import { displayDateFormat, downloadReportsFun, getArrayOfSelectedStoresCode } from '../../utils/helpers';
import { icons } from '../../assets/icons';

const MINUTE_MS = 30000;

const SapReport = () => {
  const { data = [], apiCall } = useApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    user: { userLabel = "Store" },
    selectedStores,
    storeDropdownState
  } = useAuth();

  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );

  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );

  const [reportList, setReportList] = useState([]);
  const [isGenerated, setIsGenerated] = useState(false);

  const isStoreActive = userLabel == "Store";
  
  useEffect(() => {
    // if(isStoreActive){
      voucherApiCall(startDate, endDate, selectedStores);
    // } else {
    //   if((storeCode.length > 0) && (storeCode.length !== 0)){
    //     voucherApiCall(startDate, endDate);
    //   }
    // }
  }, [selectedStores]);

  useEffect(() => {
    if (isGenerated) {
      const interval = setInterval(() => {
          getGenerateReport();
      }, MINUTE_MS);
      return () => clearInterval(interval);
    }
  }, [isGenerated])

  const {storeCode = ""} = selectedStores?.storeDetails || selectedStores?.[0] || {}
  
  const {data: fileData,  apiCall: fileDownload } = useApi();
  const {data: reportData,  apiCall: generateReport } = useApi();

  const onGenerateReport = () => {
    const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    let payload = { "endDate": et, "metaDataSchemaId": 4, "reportType": "SAP", "startDate": st, "stores": getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)}
    generateReport({
      url: apiUrls.storeService.asyncDownload,
      method: 'post',
      dataToSend: payload,
      responseData: (response) => {
        if (response.status === 200) {
          setIsGenerated(true);
          toast.success(response.data?.data);
          getGenerateReport();
        } else {
          toast.error("Something Went Wrong");
        }
      }
    })
  }
  const {data: getReportData,  apiCall: getReport } = useApi(false);
  const getGenerateReport = () => {
    const st =`${moment(startDate).format('YYYY-MM-DD')} 00:00:00`;
    const et = `${moment(endDate).format('YYYY-MM-DD')} 23:59:59`;
    let payload = { "endDate": et, "metaDataSchemaId": 4, "reportType": "SAP", "startDate": st, "stores": getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)}
    getReport({
      url: apiUrls.storeService.getAll,
      method: 'post',
      dataToSend: payload,
      responseData: (response) => {
        if (response.status === 200) {
          setReportList(response.data?.data);
        } else {
          toast.error("Something Went Wrong");
          setReportList([]);
        }
      }
    })
  }
  const downloadFileFun = (record) => {
      fileDownload({
        url: `${apiUrls.storeService.download}?id=${record?.id}`,
        method: "get",
        responseType: "blob",
        responseData: (res) => {
          const { data = "", status = null } = res || {};
          const contentType = res?.headers?.["content-type"];
          const contentDisposition = res?.headers["content-disposition"];
          const fileNameMatch =
            contentDisposition && contentDisposition.match(/filename="(.+)"/);
          const fileName = fileNameMatch
            ? fileNameMatch[1]
            : record?.fileName;
          if(status === 200) {
            toast.success("Download File Successfully");
            downloadReportsFun(data, fileName, contentType);
          } else {
            toast.success("Something Went Wrong");
          }
        },
      });
  }
  const voucherApiCall = (start, end, store) => {
    // navigate(
    //   {
    //     pathname: window.location.pathname,
    //     search: createSearchParams({
    //       startDate: start,
    //       endDate: end,
    //     }).toString(),
    //   },
    //   { replace: true }
    // );
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 4,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: "",
          status: "APPROVED",
          storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState)
          // storeCodes: selectedStores?.storeDetails?.storeCode
          // ? selectedStores?.storeDetails?.storeCode !== "All" ? [selectedStores?.storeDetails?.storeCode] : null
          // : userLabel == "Store" ? null : storeCode ? [storeCode] : [selectedStores[0]?.storeCode],
        },
        method: "post",
        processData: userLabel === "Store",
        accessor: "storeGetResponse",
        itemAccessor: "dataModalRecordsResponse",
      });
  };

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end) voucherApiCall(start, end);
  };

  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);

  const columns = [
    {
      Header: "Start Date",
      accessor: "submittedOn",
      // Cell: (props) => {
      //   // Input date
      //   const inputDate = moment(props?.row?.original?.submittedOn);

      //   // Add 7 days
      //   const resultDate = inputDate.subtract(7, 'days');

      //   // Format the result
      //   const formattedResult = resultDate.format(displayDateFormat);
      //   const value = formattedResult;
      //   return value || "-";
      // },
    },
    {
      Header: "End Date",
      // Cell: (props) => {
      //   // Input date
      //   const inputDate = moment(props?.row?.original?.submittedOn);

      //   // Add 7 days
      //   const resultDate = inputDate.add(7, 'days');

      //   // Format the result
      //   const formattedResult = resultDate.format(displayDateFormat);
      //   const value = formattedResult;
      //   return value || "-";
      // },

      Cell: (props) => {
        const value = props?.row?.original?.approvedOn;
        return value || "-";
      },
    },
    {
      Header: "Voucher ID",
      accessor: "id",
    },
    {
      Header: "Approved On",
      // accessor: "submittedO",
      Cell: (props) => {
        const value = props?.row?.original?.approvedOn;
        return value || "-";
      },
    },
    {
      Header: "Approved Amount",
      accessor: "approvedAmount",
      // Cell: (props) => {
      //   const value = props?.row?.original?.cash_deposit;
      //   return value || "-";
      // },

      Cell: (props) => {
        const value = props?.row?.original?.approvedAmount;
        return Math.trunc(Number(value)*100)/100
        // return value ? Number(value).toFixed(2) : "-";
      },
    },
  ];

  const memoStoreColumns = useMemo(() => columns, [storeCode]);


  const reportColumns = [
    {
      Header: "Report Type",
      accessor: "reportType",
    },
    {
      Header: "Start Date",
      accessor: "startDate",
    },
    {
      Header: "End Date",
      accessor: "endDate"
    },
    {
      Header: "File Size(mb)",
      accessor: "fileSize",
    },
    {
      Header: "Status",
      accessor: 'status'
    },
    {
      Header: "Generation",
      accessor: "createdAt",
    },
    {
      Header: "File Name",
      accessor: "fileName",
    },
    {
      Header: " ",
      Cell: (props) => {
        if (props?.row?.original?.status === 'SUCCESS') 
        return <img
          alt="download icon"
          className="w-[2.1rem] h-[1.9rem] cursor-pointer ml-4"
          src={icons.downloadIcon}
          onClick={() => {
              downloadFileFun(props?.row?.original)
          }}
        />
        return null;
      },
    },
  ];

  // const memoReportColumns = useMemo(() => reportColumns, [storeCode]);


  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="SAP Report"
        showBack={false}
        containerClassName="mt-14"
        // renderRight={() => {
        //   if (userLabel !== "Store") {
        //     return null;
        //   }
        //   return (
        //     <CustomButton
        //       title="Submit Cash Deposit"
        //       icon={icons.plusIcon}
        //       onClick={onClickSubmitCashDeposit}
        //     />
        //   );
        // }}
      />
      <div className="flex flex-col bg-[var(--whiteColor)] rounded-[1rem] mt-8 px-4 py-7">
        <div className="flex items-center gap-x-3 self-end mb-8">
          <div className="font-size-medium">Date Range</div>
          <DatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onChangeDate}
            maxDate={new Date()}
            dateRange
          />
        </div>
        <CustomTable
          // data={data?.storeWiseRecordsResponses?.[0]?.documents !== undefined ? data?.storeWiseRecordsResponses[0]?.documents : [] }
          data={data?.storeWiseRecordsResponses?.[0]?.documents !== undefined ? data.storeWiseRecordsResponses?.flatMap(i => i.documents) : [] }
          columns={memoStoreColumns}
          // showCheckboxes={true}
          // onCheckboxSelect={(selectedCheckBoxes) => {
          //   if(data?.storeWiseRecordsResponses?.[0]?.documents?.length > 0){
          //     setSelectedCheckBoxes(selectedCheckBoxes);
          //   }
          // }}
        />
        {data?.storeWiseRecordsResponses?.[0]?.documents !== undefined ? <CustomButton
          title="Generate Report"
          wrapperClassName={`self-end !px-10 mt-5`}
          onClick={onGenerateReport}
        /> : null}
      </div>
      {reportList[0] ? <div className="flex flex-col bg-[var(--whiteColor)] rounded-[1rem] mt-8 px-4 py-7">
        <strong className="font-size-large mb-5">Download Generated Reports</strong>
        <CustomTable
          // data={data?.storeWiseRecordsResponses?.[0]?.documents !== undefined ? data.storeWiseRecordsResponses?.flatMap(i => i.documents) : [] }
          data={reportList}
          columns={reportColumns}
        />
      </div> : null }
    </div>
  )
}

export default SapReport